import { motion } from "framer-motion";
import {
  UserPlus,
  BookOpen,
  BrainCircuit,
  Award,
} from "lucide-react";

const steps = [
  {
    icon: UserPlus,
    title: "Register",
    desc: "Create your account and access personalized learning paths.",
  },
  {
    icon: BookOpen,
    title: "Learn",
    desc: "Take interactive courses, videos, and assessments.",
  },
  {
    icon: BrainCircuit,
    title: "Practice with AI",
    desc: "Receive instant feedback from AI-powered learning assistants.",
  },
  {
    icon: Award,
    title: "Get Certified",
    desc: "Earn certificates to validate your skills and competencies.",
  },
];

export default function LearningJourney() {
  return (
    <section className="bg-slate-950 py-28">
      <div className="container mx-auto px-6">

        <div className="text-center max-w-2xl mx-auto mb-20">
          <p className="text-cyan-400 font-semibold uppercase tracking-wider">
            Learning Journey
          </p>

          <h2 className="text-5xl font-bold text-white mt-3">
            Simple Learning Process
          </h2>

          <p className="text-slate-400 mt-6">
            Everything is designed to make learning easy,
            engaging and measurable.
          </p>
        </div>

        <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-8">

          {steps.map((step, index) => {
            const Icon = step.icon;

            return (
              <motion.div
                key={index}
                whileHover={{ y: -8 }}
                className="relative rounded-3xl border border-white/10 bg-slate-900 p-8"
              >

                <span className="absolute top-5 right-5 text-6xl font-black text-white/5">
                  0{index + 1}
                </span>

                <div className="w-16 h-16 rounded-2xl bg-cyan-500/10 flex items-center justify-center text-cyan-400 mb-6">
                  <Icon size={30} />
                </div>

                <h3 className="text-xl font-bold text-white">
                  {step.title}
                </h3>

                <p className="text-slate-400 mt-4 leading-7">
                  {step.desc}
                </p>

              </motion.div>
            );
          })}
        </div>

      </div>
    </section>
  );
}